/**
 * Google Analytics 4 measurement ID.
 * Override with NEXT_PUBLIC_GA_MEASUREMENT_ID in env if needed.
 */
export const GA_MEASUREMENT_ID =
  process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID?.trim() || "G-P1F94KG9NN";

export function isAnalyticsEnabled(): boolean {
  return Boolean(GA_MEASUREMENT_ID);
}
